const type = "PRO/";

export const proConstants = {
  //#region User listing constants

  UPDATE_BASIC_DETAIL_REQUEST: `${type}UPDATE_BASIC_DETAIL_REQUEST`,
  UPDATE_BASIC_DETAIL_SUCCESS: `${type}UPDATE_BASIC_DETAIL_SUCCESS`,
  UPDATE_BASIC_DETAIL_FAILURE: `${type}UPDATE_BASIC_DETAIL_FAILURE`,
};